export const supportedLanguages = ['sv', 'en'];
export const defaultLanguage = supportedLanguages[0];
